import React from 'react';
import { useTranslation } from 'react-i18next';
import RoundedButton from 'components/MuiComponents/RoundedButton';
import { PhotoOutlineIcon } from 'components/StyledIcons/StyledIcons';
import PropTypes from 'prop-types';

const photoIconStyle = {
  root: {
    height: '1.25rem',
    width: '1.25rem',
    color: '#343434',
    marginRight: '0.5rem',
  }
};

const galleryBtnStyle = {
  root: {
    height: '3rem',
    borderRadius: '24px',
    boxShadow: '1px 2px 8px 1px rgba(0, 0, 0, 0.12)',
    border: 'solid 0.5px rgba(180, 180, 180, 0.6)',
    backgroundColor: '#ffffff',
    '&:active, &:hover': {
      backgroundColor: '#f6f7f7',
      color: '#343434',
    },
  }
};

export const DesktopGalleryButton = ({ onClick }) => {
  const { t } = useTranslation('new-version');
  return (
    <RoundedButton onClick={onClick} overwritestyles={galleryBtnStyle}>
      <PhotoOutlineIcon overwritestyles={photoIconStyle} />
      <span>{t('NEW_ITINERARY.GALLERY')}</span>
    </RoundedButton>
  );
};

DesktopGalleryButton.propTypes = {
  onClick: PropTypes.func,
};

DesktopGalleryButton.defaultProps = {
  onClick: () => {},
};

export default DesktopGalleryButton;
